import React from 'react';
import { GroupForListType } from '../types';
import { COLOR_APP_PRIMARY } from '../theme';

export const getTenantLinkForGroups = (group: GroupForListType) => (
    <a
        href={`/tenants/${group.ownerTenantId}`}
        target="_blank"
        style={{ color: COLOR_APP_PRIMARY }}
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
    >
        {group.ownerTenantName}
    </a>
);

export const getTenantLinkForArticles = (article: { tenantId: number; tenantName: string }) => (
    <a
        href={`/tenants/${article.tenantId}`}
        target="_blank"
        style={{ color: COLOR_APP_PRIMARY }}
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
    >
        {article.tenantName}
    </a>
);

export default getTenantLinkForGroups;
